module.exports = __webpack_public_path__ + "img/H-B-123456-unload-standup-base.97cf7512.png";